import { Modal as ModalBase, ModalOverlay } from "@ecco/ui/modal";
import type { ComponentProps, PropsWithChildren } from "react";
import { useBreakpoint } from "@ecco/ui/use-breakpoint";

type ModalProps = PropsWithChildren<{
    onClose?: () => void;
    onOverlayClick?: ComponentProps<typeof ModalBase>["onOverlayClick"];
    closeOnOverlayClick?: boolean;
    size?: ComponentProps<typeof ModalBase>["size"];
    returnFocusOnClose?: ComponentProps<typeof ModalBase>["returnFocusOnClose"];
    isOpen?: ComponentProps<typeof ModalBase>["isOpen"];
    initialFocusRef?: React.RefObject<HTMLElement | null>;
    finalFocusRef?: ComponentProps<typeof ModalBase>["finalFocusRef"];
}>;

const Modal = ({
    onClose,
    onOverlayClick,
    closeOnOverlayClick = true,
    size,
    children,
    initialFocusRef,
    finalFocusRef,
    isOpen,
    returnFocusOnClose,
}: ModalProps) => {
    const sm = useBreakpoint("sm");
    const animationDirection = sm ? "slideInRight" : "slideInBottom";

    return (
        <ModalBase
            isOpen={isOpen ?? true}
            onClose={onClose}
            onOverlayClick={onOverlayClick}
            closeOnOverlayClick={closeOnOverlayClick}
            motionPreset={animationDirection}
            size={size}
            initialFocusRef={initialFocusRef}
            finalFocusRef={finalFocusRef}
            returnFocusOnClose={returnFocusOnClose}
        >
            <ModalOverlay />
            {children}
        </ModalBase>
    );
};

export default Modal;
